import { useEffect } from 'react';

const useOutsideClick = ({ ref, onClick, updateProperty }) => {
  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        onClick(event);
      }
    };

    document.addEventListener('mousedown', handleOutsideClick, true);

    return () =>
      document.removeEventListener('mousedown', handleOutsideClick, true);
  }, [ref, updateProperty]);
};

export default useOutsideClick;
